import { Button, Container, Dropdown } from '@/components';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { BsFileEarmarkText, BsCalendarDate } from 'react-icons/bs';
import { FaUsers, FaRedo, FaTimes, FaSearch } from 'react-icons/fa';
import { usePaymentReminder } from '@/context/paymentReminderContext/PaymentReminderContextProvider';
import CustomerEmailTable from './CustomerEmailTable';
import {
  ModalProvider,
  useModal,
} from '@/components/common/modal/ModalContext';
import EmailTemplate from './EmailTemplate';
import { SiMinutemailer } from 'react-icons/si';

const FileInfo = () => {
  const { fileId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { fileName, uploadDate, totalCustomer } = location.state || {};
  const [selectedOption, setSelectedOption] = useState('');
  const { openModal, closeModal } = useModal();

  const {
    getPaymentReminderFileByFileIdAPI,
    setSingleFileData,
    singleFileData,
    paymentReminderSenderEmailAPI,
    sendEmailRecordsAPI,
    paymentReminder,
    setPaymentReminder,
    intialState,
  } = usePaymentReminder();

  useEffect(() => {
    if (!fileId) {
      navigate('/set-reminder');
    } else {
      setPaymentReminder(intialState);
    }
  }, [fileId]);

  const handleGetRecords = () => {
    if (selectedOption) {
      getPaymentReminderFileByFileIdAPI(fileId, selectedOption);
      paymentReminderSenderEmailAPI();
    }
  };

  const handleReset = () => {
    setSelectedOption('');
    setSingleFileData(null);
    // Do not reset "From" and "Reminder"
  };

  const filterType = [
    { label: 'All', value: 'all' },
    { label: '60', value: '60' },
    { label: '90', value: '90' },
    { label: '60-90', value: '60-90' },
  ];

  const handleOpenModal = () => {
    openModal(<EmailTemplate closeModal={closeModal} />, 'Email Template');
  };

  const handleSendMail = () => {
    sendEmailRecordsAPI();
  };

  // Determine if Send Mail button should be disabled
  const isSendMailDisabled =
    !paymentReminder?.template?.id ||
    paymentReminder?.template?.id === 0 ||
    paymentReminder?.emailSender?.id === 0 ||
    !paymentReminder?.emailSender?.id ||
    !paymentReminder?.file?.fileLogs ||
    paymentReminder?.file?.fileLogs.length === 0;

  // Helper function to convert UTC date string to local date string
  const toLocalDateString = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    if (isNaN(date)) return dateString;
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  return (
    <>
      <Container title="File Details">
        <div className="grid grid-cols-2 gap-4 mx-20 my-5">
          <div>
            <span className="font-bold flex items-center gap-2">
              <BsFileEarmarkText /> File Name:
              <span className="font-normal">{fileName || 'N/A'}</span>
            </span>
          </div>
          <div>
            <span className="font-bold flex items-center gap-2">
              <BsCalendarDate /> Upload Date:
              <span className="font-normal">
                {toLocalDateString(uploadDate)}
              </span>
            </span>
          </div>
          <div>
            <span className="font-bold flex items-center gap-2">
              <FaUsers /> Customers:
              <span className="font-normal">{totalCustomer || 'N/A'}</span>
            </span>
          </div>
          <div className="flex items-center gap-2">
            <span className="font-bold">Filter:</span>
            <Dropdown
              name="filterType"
              options={filterType}
              value={selectedOption}
              disabled={!!singleFileData}
              onChange={(e) => setSelectedOption(e.target.value)}
            />
          </div>
        </div>
        <div className="flex justify-center gap-5 w-full mb-5">
          <Button
            onClick={handleGetRecords}
            disabled={!selectedOption || !!singleFileData}
          >
            <FaSearch className="mr-2" /> Fetch
          </Button>
          <Button onClick={handleReset}>
            <FaRedo className="mr-2" /> Reset
          </Button>
          <Button onClick={() => navigate('/set-reminder')}>
            <FaTimes className="mr-2" /> Back
          </Button>
        </div>
      </Container>

      {singleFileData && (
        <>
          {singleFileData.fileLogs && singleFileData.fileLogs.length > 0 ? (
            <>
              <CustomerEmailTable selectedOption={selectedOption} />
              <div className="flex justify-end mx-20 gap-5">
                <Button onClick={handleOpenModal}>
                  <FaSearch className="mr-2" /> Select Template
                </Button>
                <Button onClick={handleSendMail} disabled={isSendMailDisabled}>
                  <SiMinutemailer className="mr-2" /> Send Mail
                </Button>
              </div>
            </>
          ) : (
            <div className="text-center text-gray-500 my-5 text-2xl">
              No data found for {selectedOption}
            </div>
          )}
        </>
      )}
    </>
  );
};

const App = () => (
  <ModalProvider>
    <FileInfo />
  </ModalProvider>
);

export default App;
